import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Subcategoria`

export function buscarTodosPorIdCategoria(
  idCategoria,
  esScrap = false,
  buscar = '',
  vieneDePublicaciones
) {
  const params = {}

  if (buscar) {
    params.buscar = buscar
  }

  if (vieneDePublicaciones !== undefined) {
    params.vieneDePublicaciones = vieneDePublicaciones
  }

  return http.get(`${API_ENDPOINT}/BuscarTodosPorIdCategoria/${idCategoria}/${esScrap}`, {
    params,
    meta: {
      toastMessage: 'Ocurrió un error al obtener las subcategorías.',
      tipoError: 'subcategorias'
    }
  })
}
